// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface MoveLeftRightIconSignature {
  Element: SVGSVGElement;
}

export const MoveLeftRightIcon: TOC<MoveLeftRightIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M6 10.996H21C21.404 10.996 21.77 10.752 21.924 10.379C22.078 10.005 21.993 9.575 21.707 9.289L16.707 4.289L15.293 5.703L18.586 8.996H6V10.996Z"/>
<path d="M18 12.996H3C2.596 12.996 2.23 13.24 2.076 13.613C1.922 13.987 2.007 14.417 2.293 14.703L7.293 19.703L8.707 18.289L5.414 14.996H18V12.996Z"/>
</svg>
</template>;